module.exports = __webpack_public_path__ + "6dc26e21.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/ClinicaMedica/24581.jpg
// module id = 1318
// module chunks = 0 1